import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import {pink,purple} from '@mui/material/colors';
import { ResponsiveContainer} from 'recharts';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L, { LatLngBoundsExpression } from 'leaflet';
import { LatLngExpression } from 'leaflet';
//import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
//import metericon from '../icons/meter.png';
import apply from '../icons/receipt.svg';
import pay from '../icons/pay-per-click.svg'
import submit from '../icons/submit.svg'
import process from '../icons/thinking.svg'
import complete from '../icons/task-complete.svg'
// import nrmms3410 from '../icons/nrmms_3410.png';
// import nfmms1405 from '../icons/nfmms_1405.png';
// import nfmms3410 from '../icons/nfmms_3410.png';

const styles = (theme:Theme):any => ({
  maproot: {
    flexGrow: 1,
    flexShrink: 1,
  },
  mapboardpaper: {
    backgroundColor: 'white',
    //maxHeight: 600,
    height: '100%',
    // height: 150
    marginLeft: 10,
    marginRight: 10,
  },
  mapdiv: {
    // height: 95,
    //padding: '5px 15px 0 15px'
  },
  mapheader: {
    fontSize: 24,
    fontWeight: theme.typography.fontWeightLight,
    color: 'white',
    backgroundColor: purple['600'],
    padding: 10,
  },
  paper: {
    backgroundColor: 'white',
    minHeight: 400,
    // overFlow: 'hidden'
    height: '100%',
    marginTop: 10,
  },
  div: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '95%',
    //height: 300,
  },
  header: {
    color: 'white',
    backgroundColor: pink['600'],
    padding: 10,
    fontSize: 24,
    fontWeight: 300,
  },
  custom_tooltip:{
    lineHeight: 0.2,
    backgroundColor: 'white',
    padding: 5
  },
  nodata: {
    display: 'flex',
    justifyContent: 'center'
  },
  barchart:{
    marginTop: 20
  }
});

const ntrmsicons:any = {
  REQUEST:L.icon({iconUrl:apply,shadowUrl:iconShadow}),
  PAYMENT:L.icon({iconUrl:pay,shadowUrl:iconShadow}),
  SUBMISSION:L.icon({iconUrl:submit,shadowUrl:iconShadow}),
  PROCESSING:L.icon({iconUrl:process,shadowUrl:iconShadow}),
  SUBTASK:L.icon({iconUrl:process,shadowUrl:iconShadow}),
  COMPLETE:L.icon({iconUrl:complete,shadowUrl:iconShadow}),
  DELIVERY:L.icon({iconUrl:complete,shadowUrl:iconShadow}),
}

const ntrmsicon = L.icon({iconUrl:process,shadowUrl:iconShadow});

let DefaultIcon = L.icon({
  iconUrl: complete,
  shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;

/*

var myIcon= L.Icon.extend({
        options: {
            iconUrl: 'icon.png',
            iconSize: [7.5, 7.5],
            iconAnchor: [0, 0]
        }
    });

var ic = new myIcon({iconSize: [7.5, 7.5]});
    var marker = L.marker([-15.7745457, -48.3575684], {icon: ic}).addTo(map);

map.on('zoomend', function() {
var actualZoom = map.getZoom();
var newSize = 60/((20 - actualZoom )*2);

var resizedIcon = new myIcon({iconSize: [newSize ,newSize ]});      
marker.setIcon(resizedIcon );
});

*/

class EventMap extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  map:any;
  constructor(props:any) {
    super(props);

    this.map = createRef();

    const {mapper={}} = this.props;
    const {cc=[5.64046614, -0.2921927]} = mapper;
    const {bb=[[4.71046214438, -3.24437008301],[11.0983409693, 1.0601216976]]} = mapper;
    const mcenter:LatLngExpression = cc; //||[8.977850, 39.253099];
    const mpos:LatLngExpression = cc; //||[9.01055, 38.74750];
    const mtext = `NTRMS Event. <br /> Event Location.`;
    const mbounds:LatLngBoundsExpression = bb;
    const mzoom = 14;
    const mtitle = 'Event Map';
    
    const {title=mtitle,mapcenter=mcenter,mapbounds=mbounds,mapzoom=mzoom,mappos=mpos,maptext=mtext,markerpos=mpos,markertext=mtext} = props;

    this.state = {
      count: 0,
      mtitle:title,
      mcenter:mapcenter,
      mbounds:mapbounds,
      mzoom:mapzoom,
      mpos:mappos,
      mtext:maptext,
      mkpos:markerpos,
      mktet:markertext,
    };
  }

  componentDidMount(): void {
      const cmap = this.map.current;
      console.log('map',cmap);
  }

  render() {
    const {classes} = this.props;
    const {mtitle,mcenter,mbounds,mzoom,mpos,mtext,mkpos,mktext} = this.state;
    const {
      title=mtitle,recordset=[],mapcenter=mcenter,mapbounds=mbounds,mapzoom=mzoom,
      mappos=mpos,maptext=mtext,markerpos=mkpos,markertext=mktext
    } = this.props;

    return (
      <Paper className={classes.paper}>
        <div className={classes.header}>{title}</div>
        <div className={classes.div}>
          <ResponsiveContainer >
            <MapContainer ref={this.map} center={mapcenter} zoom={mapzoom} scrollWheelZoom={false} style={{height:'80vh',width:'100%'}} bounds={mapbounds}>
              <TileLayer
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" bounds={mapbounds}
              />
              <Marker position={mappos} icon={DefaultIcon}>
                <Popup>
                  {maptext}
                </Popup>
              </Marker>
              {recordset.map((record:any, idx:number) => 
                <Marker key={record.rid} position={record.geo} icon={ntrmsicons[record.evc]}>
                <Popup>
                  <span>TRACK:{record.tri}<br/>REF:{record.rfn}<br/>MDA:{record.enc}<br/>EVENT: {record.evc}<br/>ACTIVITY: {record.acc}<br/>STATUS: {record.vsc}<br/>DATE: {record.dcd}</span>
                </Popup>
              </Marker>
              )}
            </MapContainer>
          </ResponsiveContainer>
        </div>
      </Paper>
    );
  }
}

EventMap.propTypes = {
  data: PropTypes.array
};

export default withStyles(styles, { withTheme: true })(EventMap);



/*
  /////////////////// OTHER METHODS  ////////////////////////


  startLoading = () => {
    this.setState({loading:true});
  }

  stopLoading = () => {
    this.setState({loading:false});
  }


  //////////////////////////////map//////////////////////////////
  mapload = async(filename:string) => {
    try{
      const baseparams = {filename}; //,sta:date
      const response = await apipost('/api/resource/map','',baseparams);
      //this.setState({markers:response.sd});
      //this.map.addLayer(this.liveLayer);
      //this.liveLayer.clearLayers();
      //this.loadMakersLeaflet();
      return response; //TODO: return file
    }
    catch(error){
      console.log('map.bizpost error',error);
      return Promise.reject(error);
    } 
    //TODO: call LoadMarkers
    
  }

  baseload = async() => {
    try{
      return await this.mapload('ghana-regions.json');
    }
    catch(error){
      console.log('baseload error',error);
      return Promise.reject(error);
    } 
  }

  placesload = async() => {
    try{
      return await this.mapload('ghana-towns.json');
    }
    catch(error){
      console.log('placesload error',error);
      return Promise.reject(error);
    } 
  }



    liveLoad = async(code:any,date:any) => {
      try{
        const {recordset:previousset,lastread} = this.state;
        const {eni} = this.props;
        //const start = moment.format()
        const baseparams = {s:'marker',a:'find',eni,stp:lastread};
        const response = await bizpost(baseparams);
        const {sd:currentset} = response;
        const recordset = this.merge('rid',previousset,currentset);
        this.setState({recordset,previousset,currentset});
        //this.map.addLayer(this.liveLayer);
        //this.liveLayer.clearLayers();
  
        //this.loadMakersLeaflet();
      }
      catch(error){
        console.log('map.bizpost error',error);
      } 
      //TODO: call LoadMarkers
      
    }
  
    ttFormatTime = (stamp:any) => {
      return moment.unix(stamp).format('DD MMM');
    }
  
    /////////////////  ACCESSING THE MAP VANILLA JS/HTML////////////////////////
    var map = L.map('map').setView([55.4411764, 11.7928708], 13);

    L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    // quick and dirty: create a big icon
    L.Icon.Big = L.Icon.Default.extend({
        options: {
        iconSize: new L.Point(45, 81),
    }});

    var bigIcon = new L.Icon.Big();
    var centerPoint = L.latLng(55.4411764, 11.7928708);
    var centerMarker = L.marker(centerPoint, { title: 'unselected' });
    centerMarker.addTo(map);

    centerMarker.on('click', function(e) {
        centerMarker.setIcon(bigIcon);
    });
    */